module.exports = __webpack_public_path__ + "static/img/sjbk2.5e9e629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/sjbk2.png
// module id = AZaM
// module chunks = 15